import Enums from "@/enums/enums";
import userInfo from "@/function/userInfo";
import i18n from "@/locales/i18n";

export default {
  GetQuotationReportParameter(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPurchaseOrderAsset: input.reportCriteria.isShowPurchaseOrderAsset,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromActionDate: input.reportCriteria.transactionSearchCriteria.fromAcceptedDate,
      toActionDate: input.reportCriteria.transactionSearchCriteria.toAcceptedDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      isShowPurchaseOrderAsset: input.reportCriteria.isShowPurchaseOrderAsset,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetInvoiceReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowDepositReceiptGroup: input.reportCriteria.isShowDepositReceiptGroup,
      isShowDepositPaymentGroup: input.reportCriteria.isShowDepositPaymentGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetReceiptReportParameterModel(input) {
    let reportParameter = {
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowDepositReceiptGroup: input.reportCriteria.isShowDepositReceiptGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowEtaxInvoiceStatus: input.reportCriteria.isShowEtaxInvoiceStatus,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetTaxInvoiceReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowEtaxInvoiceStatus: input.reportCriteria.isShowEtaxInvoiceStatus,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      filterETaxInvoiceType: input.reportCriteria.filterETaxInvoiceType,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetCreditNoteReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      isShowEtaxInvoiceStatus: input.reportCriteria.isShowEtaxInvoiceStatus,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetDebitNoteReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetBillingNoteReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetJournalReportParameterModel(input) {
    let reportParameter = {
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.journalTable.tableStatus,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isShowDeleted: input.isShowDeleted,
      isShowClassificationGroup: input.isShowClassificationGroup,
      isShowOthersGroup: input.isShowOthersGroup,
      isShowHistoryGroup: input.isShowHistoryGroup,
      excelHeaderDetailLocation: input.excelHeaderDetailLocation,
      reportTemplateType: input.reportTemplateType,
      searchText: input.journalTable.searchText,
      journalTableType: input.journalTable.journalTableType,
      tableSorting: input.journalTable.tableSorting,
      journalTableView: input.journalTable.journalTableView,
      journalReasonFilterTypeList: input.journalTable.journalReasonFilterTypeList,
      contactId: input.journalTable.searchAdvance.contactId,
      searchNumber: input.journalTable.searchAdvance.searchTextTransactionNumber,
      searchReference: input.journalTable.searchAdvance.searchTextReference,
      searchDescription: input.journalTable.searchAdvance.searchTextTransactionDescription,
      journalAccountDescription: input.journalTable.searchAdvance.searchTextTransactionItemDescription,
      tagIdList: input.journalTable.searchAdvance.tagIdList,
      isAllTagSearch: input.journalTable.searchAdvance.isAllTagSearch,
      createdUserId: input.journalTable.searchAdvance.createdUserId,
      approvedUserId: input.journalTable.searchAdvance.approvedUserId,
      reviewedUserId: input.journalTable.searchAdvance.reviewedUserId,
      accountId: input.journalTable.searchAdvance.accountId,
      journalAccountReferenceId: input.journalTable.searchAdvance.accountReferenceId,
      journalAccountReferenceTypeId: input.journalTable.searchAdvance.accountReferenceType,
      allocationIdList: input.journalTable.searchAdvance.allocationIdList,
      allocationItemIdList: input.journalTable.searchAdvance.allocationItemIdList,
      isNotHaveAllocation: input.journalTable.searchAdvance.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.journalTable.searchAdvance.isNotHaveAnyAllocation,
      fromNetAmount: input.journalTable.searchAdvance.fromNetAmount,
      toNetAmount: input.journalTable.searchAdvance.toNetAmount,
      fromCreatedDate: input.journalTable.searchAdvance.fromCreatedDate,
      toCreatedDate: input.journalTable.searchAdvance.toCreatedDate,
      fromApprovedDate: input.journalTable.searchAdvance.fromApprovedDate,
      toApprovedDate: input.journalTable.searchAdvance.toApprovedDate,
      fromReviewedDate: input.journalTable.searchAdvance.fromReviewedDate,
      toReviewedDate: input.journalTable.searchAdvance.toReviewedDate,
    };
    return reportParameter;
  },
  GetDepositReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetInvoiceReveiveReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowPaymentRecordGroup: input.reportCriteria.isShowPaymentRecordGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      isShowDepositPaymentGroup: input.reportCriteria.isShowDepositPaymentGroup,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetGoodsReveiveReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetProductTemplateReportParameters(input) {
    return {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      language: i18n.locale,
      source: Enums.SourceTypeProject.PeakExperience,
      fromDate: input.fromDate,
      toDate: input.toDate,
      productTemplateType: input.productTemplateType,
      excelHeaderDetailLocation: input.excelHeaderDetailLocation,
      isShowAccount: input.isShowAccount,
      isProductHaveMovement: input.isProductHaveMovement,
      isShowRemainGL: input.isShowRemainGL,
      isShowStandardPrice: input.isShowStandardPrice,
      isShowSkuAndBarcode: input.isShowSkuAndBarcode,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
    };
  },
  GetPurchaseRequisitionReportParameterModel(input) {
    let reportParameter = {
      financeType: input.financeTypeId,
      transactionItemType: input.transactionItemTypeId,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableStatus: input.reportCriteria.tableStatus,
      fromDate: input.reportCriteria.fromDate,
      toDate: input.reportCriteria.toDate,
      searchText: input.reportCriteria.searchText,
      isShowPriceAndTaxGroup: input.reportCriteria.isShowPriceAndTaxGroup,
      isShowClassificationGroup: input.reportCriteria.isShowClassificationGroup,
      isShowOthersGroup: input.reportCriteria.isShowOthersGroup,
      isShowHistoryGroup: input.reportCriteria.isShowHistoryGroup,
      isShowDeleted: input.reportCriteria.isShowDeleted,
      reportTemplateType: input.reportCriteria.reportTemplateType,
      excelHeaderDetailLocation: input.reportCriteria.excelHeaderDetailLocation,
      tableSorting: input.reportCriteria.tableSorting,
      transactionTableView: input.reportCriteria.transactionTableView,
      contactId: input.reportCriteria.transactionSearchCriteria.contactId,
      searchNumber: input.reportCriteria.transactionSearchCriteria.searchTextTransactionNumber,
      searchReference: input.reportCriteria.transactionSearchCriteria.searchTextReference,
      fromDueDate: input.reportCriteria.transactionSearchCriteria.fromDueDate,
      toDueDate: input.reportCriteria.transactionSearchCriteria.toDueDate,
      fromAcceptTaskDate: input.reportCriteria.transactionSearchCriteria.fromAcceptTaskDate,
      toAcceptTaskDate: input.reportCriteria.transactionSearchCriteria.toAcceptTaskDate,
      fromPaymentDate: input.reportCriteria.transactionSearchCriteria.fromPaymentDate,
      toPaymentDate: input.reportCriteria.transactionSearchCriteria.toPaymentDate,
      fromNetAmount: input.reportCriteria.transactionSearchCriteria.fromNetAmount,
      toNetAmount: input.reportCriteria.transactionSearchCriteria.toNetAmount,
      searchTextTransactionItemDescription:
        input.reportCriteria.transactionSearchCriteria.searchTextTransactionItemDescription,
      productTemplateIdList: input.reportCriteria.transactionSearchCriteria.productTemplateIdList,
      isAllProductTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllProductTemplateSearch,
      assetTemplateIdList: input.reportCriteria.transactionSearchCriteria.fixAssetTemplateIdList,
      isAllAssetTemplateSearch: input.reportCriteria.transactionSearchCriteria.isAllFixAssetTemplateSearch,
      tagIdList: input.reportCriteria.transactionSearchCriteria.tagIdList,
      isAllTagSearch: input.reportCriteria.transactionSearchCriteria.isAllTagSearch,
      createdUserId: input.reportCriteria.transactionSearchCriteria.createdUserId,
      approvedUserId: input.reportCriteria.transactionSearchCriteria.approvedUserId,
      allocationIdList: input.reportCriteria.transactionSearchCriteria.allocationIdList,
      allocationItemIdList: input.reportCriteria.transactionSearchCriteria.allocationItemIdList,
      isNotHaveAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAllocation,
      isNotHaveAnyAllocation: input.reportCriteria.transactionSearchCriteria.isNotHaveAnyAllocation,
      receivedTaxInvoiceNumber: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: input.reportCriteria.transactionSearchCriteria.receivedTaxInvoiceDate,
      fromCreatedDate: input.reportCriteria.transactionSearchCriteria.fromCreatedDate,
      toCreatedDate: input.reportCriteria.transactionSearchCriteria.toCreatedDate,
      fromApprovedDate: input.reportCriteria.transactionSearchCriteria.fromApprovedDate,
      toApprovedDate: input.reportCriteria.transactionSearchCriteria.toApprovedDate,
    };

    return reportParameter;
  },
  GetExportWitheldTaxRequest(input) {
    return {
      tableStatus: input.tableStatus,
      fromDate: input.fromDate,
      toDate: input.toDate,
      searchText: input.searchText,
      filterReceivedWht: input.filterReceivedWht,
      sortingType: input.sortingType,
      sortBy: input.sortBy,
      isShowDeleted: input.isShowDeleted,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      language: i18n.locale,
      source: Enums.SourceTypeProject.PeakExperience,
    };
  },
  GetExportWitholdingTaxRequest(input) {
    return {
      tableStatus: input.tableStatus,
      fromDate: input.fromDate,
      toDate: input.toDate,
      searchText: input.searchText,
      filterReceivedWht: input.filterReceivedWht,
      sortingType: input.sortingType,
      sortBy: input.sortBy,
      isShowDeleted: input.isShowDeleted,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      language: i18n.locale,
      source: Enums.SourceTypeProject.PeakExperience,
    };
  },
  GetExportWitholdingTaxByPndTypeRequest(input) {
    return {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      filingDate: input.filingDate,
      pndType: input.pndType,
      isIncomeTaxTypeShortly: input.isIncomeTaxTypeShortly,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      language: i18n.locale,
      source: Enums.SourceTypeProject.PeakExperience,
    };
  },
};
